import { Loading } from 'element-ui'

const options = {
  fullscreen: true,
  customClass: 'spinner'
}

export const setScreenLoading = (val: boolean) => {
  if (val) Loading.service(options)
  else Loading.service(options).close()
}
